import React, { useState } from "react";
import { initI18n, defaultLanguage, onLanguageChanged } from "../i18n";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./App.scss";

import Langswitcher from "./langswitcher/Langswicher";
import Header from "./header/Header";
import ModeChanger from "./mode-changer/ModeChanger";
import ReportForm from "./report-form/ReportForm";
import Help from "./help/Help";

initI18n("locales/{{lng}}/translations.json", defaultLanguage);

export default function App() {
  const [language, setLanguage] = useState(defaultLanguage);
  onLanguageChanged((lng) => setLanguage(lng));

  return (
    <>
      <Router>
        {<Langswitcher></Langswitcher>}
        <div className="container-fluid overflow-hidden" id="form-page">
          <div className="container">
            <div className="row">
              <Header></Header>
              <div className="col-md-8 right pl-md-0">
                <ModeChanger></ModeChanger>
                <div className="form-container">
                  <Route
                    exact
                    path={["/", "/requests"]}
                    component={ReportForm}
                  ></Route>
                  <Route path="/requests/help" component={Help} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Router>
    </>
  );
}